<template>
  <div class="page-container">
    <!-- <div class="page-total">共{{ totalPage }}页</div> -->
    <div class="page-total" v-if="model.lang === 'zh_CN'">{{KDApi.getLangMsg(model, "tips.total") + totalPage + KDApi.getLangMsg(model, "tips.pages")}}</div>
    <div class="page-total" v-else>{{KDApi.getLangMsg(model, "tips.total") + " " + totalPage + " " + KDApi.getLangMsg(model, "tips.pages")}}</div>
    <div class="page-num" v-if="model.lang === 'zh_CN'">{{KDApi.getLangMsg(model, "tips.pageno")}}<input type="text" v-model="currPage" />{{KDApi.getLangMsg(model, "tips.page")}}</div>
    <div class="page-num" v-else>{{KDApi.getLangMsg(model, "tips.pageno")}}<input type="text" v-model="currPage" /></div>
    <div class="op-page">
      <span class="first-page">
        <i
          class="kdicon kdicon-first"
          :class="{ dis: currPage == 1 }"
          @click="currPage = 1"
        ></i>
      </span>
      <span class="next-page">
        <i
          class="kdicon kdicon-arrow-left"
          :class="{ dis: currPage == 1 }"
          @click="currPage -= 1"
        ></i>
      </span>
      <span class="pre-page">
        <i
          class="kdicon kdicon-arrow-right"
          :class="{ dis: currPage == totalPage }"
          @click="currPage += 1"
        ></i>
      </span>
      <span class="last-page">
        <i
          class="kdicon kdicon-last"
          :class="{ dis: currPage == totalPage }"
          @click="currPage = totalPage"
        ></i>
      </span>
    </div>
    <div class="page-range" ref="rangeDOm">
      <span @click="showRangeList = !showRangeList" v-if="model.lang === 'zh_CN'">{{range + KDApi.getLangMsg(model, "tips.items") + "/" + KDApi.getLangMsg(model, "tips.page")}}</span>
      <span @click="showRangeList = !showRangeList" v-else>{{range + " " + KDApi.getLangMsg(model, "tips.items") + "/" + KDApi.getLangMsg(model, "tips.page")}}</span>
      <span class="select">
        <i
          class="kdicon kdicon-arrow-down"
          :class="{ active: showRangeList }"
          @click="showRangeList = !showRangeList"
        ></i>
        <ul class="page-range_list" v-show="showRangeList">
          <li
            v-for="i in rangeList"
            :key="'range' + i"
            class="page-range_item"
            :class="{ act: i == range }"
            @click="range = i;showRangeList=false;"
          >
            <span class="item_zh" v-if="model.lang === 'zh_CN'">{{ i + KDApi.getLangMsg(model, "tips.items") + "/" + KDApi.getLangMsg(model, "tips.page")}}</span>
            <span class="item_us" v-else>{{ i + " " + KDApi.getLangMsg(model, "tips.items") + "/" + KDApi.getLangMsg(model, "tips.page")}}</span>
          </li>
        </ul>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  inject: ["model", "KDApi"],
  props: {
    total: Number,
    pageRange: Number,
  },
  data() {
    return {
      range: 20,
      rangeList: [5, 10, 20, 50, 100, 500, 1000],
      currPage: 1,
      showRangeList: false,
    };
  },
  created() {
    this.range = this.pageRange;
  },
  mounted() {
    this.closeBoard();
  },
  methods: {
    changePage() {
      if (this.currPage != '') {
        if (this.currPage < 1) {
          this.currPage = 1;
        }
        if (this.currPage > this.totalPage) {
          this.currPage = this.totalPage;
        }

        this.currPage = parseInt(this.currPage) || 1;

        this.$emit("pageChange", {
          currPage: this.currPage,
          range: this.range,
        });
      }
    },
    closeBoard() {
      document.addEventListener("click", (e) => {
        const iconEl = this.$refs.rangeDOm;
        if (iconEl && !iconEl.contains(e.target)) {
          this.showRangeList = false;
        }
      });
    },
  },
  watch: {
    currPage() {
      this.changePage();
    },
    range() {
      this.changePage();
    },
  },
  computed: {
    totalPage() {
      return Math.ceil(this.total / this.range);
    }
  },
};
</script>

<style scoped lang="less">
.page-container {
  display: flex;
  color: var(--secondary-text-color);
  font-size: 12px;
  .page-total {
    margin-right: 12px;
  }
  .page-num {
    margin-right: 15px;
    input {
      box-sizing: border-box;
      width: 32px;
      height: 24px;
      margin: 0 3px;
      padding: 0;
      outline: 0;
      text-align: center;
      background: #fff;
      color: var(--primary-text-color);
      font-size: 12px;
      border-radius: var(--radius-size);
      border: 1px solid var(--strong-border-color);
      transition: border-color 0.3s;
      &:hover {
        border-color: var(--theme-color);
      }
    }
  }
  .op-page {
    margin-right: 20px;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-variant: tabular-nums;
    list-style: none;
    font-feature-settings: "tnum";
    display: inline-block;
    vertical-align: middle;
    > span {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      font-variant: tabular-nums;
      list-style: none;
      font-feature-settings: "tnum";
      display: inline-block;
    }
    .first-page {
    }
    .next-page {
    }
    .pre-page {
    }
    .last-page {
    }
  }
  .page-range {
    cursor: pointer;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-variant: tabular-nums;
    list-style: none;
    font-feature-settings: "tnum";
    position: relative;
    display: inline-block;
    margin-left: 20px;
    outline: 0;
    height: 24px;
    vertical-align: middle;
    span {
      font-size: 12px;
      color: var(--primary-text-color);
    }
    .select {
      position: relative;
      i.kdicon-arrow-down {
        font-size: 16px;
        color: var(--secondary-text-color);
        &.active {
          transform: rotate(180deg);
        }
      }
    }

    .page-range_list {
      max-width: 320px;
      box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.2);
      position: absolute;
      max-height: 336px;
      background: #fff;
      z-index: 1050;
      right: -8px;
      padding: 8px 0;
      overflow-y: auto;
      .page-range_item {
        // min-width: 78px;
        position: relative;
        padding: 7px 12px;
        color: var(--primary-text-color);
        font-size: 12px;
        line-height: 18px;
        overflow: hidden;
        cursor: pointer;
        transition: background-color 0.3s;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        &.act {
          color: var(--theme-color);
        }
        &:hover {
          background-color: var(--disabled-contain-bg);
        }
        .item_zh {
          display: inline-block;
          width: 78px;
        }
        .item_us {
          display: inline-block;
          width: 99px;
        }
      }
    }
  }
  .kdicon {
    font-size: 16px;
    cursor: pointer;
  }

  .kdicon.dis {
    color: var(--disabled-border-color);
  }
  .kdicon:hover {
    color: var(--theme-color);
  }
}
</style>